import { Injectable, inject } from '@angular/core';
import { CLASSIC_BASKET_PAGES, withClassicBasketEntry } from '../classic-basket-entry';
import { NavigationTarget } from '../navigation-target';
import { PortalRegion } from '../portal-region';
import { REROUTED_FROM_LEGACY_PARAM, ShellRoutes } from '../portal-routes';
import { PortalUrls } from '../portal-urls.service';

/**
 * A deeplink to the classic basket (bookmark, typed or shared link; Legacy hands it over instead of serving it)
 * leads to the Order Pro basket, which tells the user why. Exception for China: buyers keep the classic basket.
 * The portal opens the classic basket with an entry token, which Legacy serves without handing it over.
 */
@Injectable({ providedIn: 'root' })
export class ClassicBasketDeeplink {
  private readonly urls = inject(PortalUrls);

  /** The target replacing the deeplink, `null` when it is no classic basket deeplink. */
  resolve(deeplink: NavigationTarget): NavigationTarget | null {
    const url = deeplink.kind === 'external' ? new URL(deeplink.url) : null;
    if (!url || !this.urls.isLegacyPortalPage(url, CLASSIC_BASKET_PAGES)) {
      return null;
    }
    if (this.urls.region === PortalRegion.China) {
      // The query is kept for the classic basket (e.g. articles to import)
      return NavigationTarget.external(withClassicBasketEntry(url.href));
    }
    return NavigationTarget.internal(`${ShellRoutes.orderProBasket}?${REROUTED_FROM_LEGACY_PARAM}=true`);
  }
}
